import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Spin, Tooltip } from 'antd';
import SignalBars from '@components/SignalBars';
import SessionContext from '@providers/Session/SessionContext';

import * as S from './styles';

const CoverageMiniTable = ({ data }: { data: any }) => {
  const { t } = useTranslation('maps');
  const { theme } = useContext(SessionContext);

  const coverageIcons = useMemo(
    () =>
      [
        <CloseCircleOutlined key={0} style={{ color: theme?.colors.red }} />,
        ...[
          theme?.colors.text,
          theme?.colors.text,
          theme?.colors.green,
          theme?.colors.green,
          theme?.colors.green,
        ].map((itemColor, index) => (
          <SignalBars
            key={itemColor}
            numberOfBars={index + 1}
            color={itemColor}
            size={20}
          />
        )),
      ].map((item, index) => (
        <Tooltip title={t(`legend.${index}`)} key={item.key}>
          <span className={!item.key ? 'no-coverage-table-icon' : ''}>
            {item}
          </span>
        </Tooltip>
      )),
    [t, theme],
  );

  const mapped = useMemo(
    () =>
      data?.anatel
        ? // @ts-ignore
          data.anatel.reduce((acc, currentCoverage) => {
            return [
              ...acc,
              <tr key={currentCoverage.operadora}>
                <td>{currentCoverage.operadora}</td>
                <td style={{ textAlign: 'center' }} className="td-signal-bars">
                  {coverageIcons[Number(currentCoverage.cobertura2g) ?? '0']}
                </td>
                <td style={{ textAlign: 'center' }} className="td-signal-bars">
                  {coverageIcons[Number(currentCoverage.cobertura3g) ?? '0']}
                </td>
                <td style={{ textAlign: 'center' }} className="td-signal-bars">
                  {coverageIcons[Number(currentCoverage.cobertura4g) ?? '0']}
                </td>
                <td style={{ textAlign: 'center' }} className="td-signal-bars">
                  {coverageIcons[Number(currentCoverage.cobertura5g) ?? '0']}
                </td>
              </tr>,
            ];
          }, [])
        : undefined,
    [data, coverageIcons],
  );

  if (!mapped) {
    return <div>-</div>;
  }

  if (mapped.length === 0) {
    return (
      <S.MapNoCoverageContainer>
        <p className="no-coverage-table-icon">
          <CloseCircleOutlined />
        </p>
        <p>{t('coverageTable.unavailable-information')}</p>
      </S.MapNoCoverageContainer>
    );
  }

  return (
    <S.MapMiniTableContainer>
      <div className="map-mini-table-title">
        {t('coverageTable.signalQuality')}
      </div>
      <div style={{ marginTop: '4px', fontSize: '0.6rem' }}>
        {data ? (
          <table style={{ width: '100%' }} className="coverage-table">
            <thead>
              <tr>
                <th
                  style={{
                    minWidth: '60px',
                    textAlign: 'center',
                  }}
                >
                  {' '}
                </th>
                <th
                  style={{
                    minWidth: '40px',
                    textAlign: 'center',
                  }}
                >
                  2G
                </th>
                <th
                  style={{
                    minWidth: '40px',
                    textAlign: 'center',
                  }}
                >
                  3G
                </th>
                <th
                  style={{
                    minWidth: '40px',
                    textAlign: 'center',
                  }}
                >
                  4G
                </th>
                <th
                  style={{
                    minWidth: '40px',
                    textAlign: 'center',
                  }}
                >
                  5G
                </th>
              </tr>
            </thead>
            <tbody>{mapped}</tbody>
          </table>
        ) : (
          <div
            style={{
              height: '136px',
              width: '200px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin />
          </div>
        )}
      </div>
    </S.MapMiniTableContainer>
  );
};

export default CoverageMiniTable;
